import type { FaireProductEntity } from "../../entity_types/product";

export const p_qpkswg7puc: FaireProductEntity = {
  token: "p_qpkswg7puc",
  type: "product",
  name: "The Wellness Journal & Planner",
  brandToken: "b_59g989rcu2",
  brandName: "Life & Apples",
  imageUrl:
    "https://cdn.faire.com/fastly/b7d9e3798197ad3d7b2514473d65dc534d8337bba43978dd2ca98874d3dbcfa6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2fdef10bc5b8dd924455219be58af483dd431830c06a2185e345ad40462e0267.png",
    "https://cdn.faire.com/fastly/9427b7b7c3a022c0edbe0524abcfb1842d9a00f7f766771ac3c7ce0ab7d66298.jpeg",
    "https://cdn.faire.com/fastly/5c4ac19d2dff9d800f0cce0f68d9720e3dbc56f36e2b9416b0dd3e3f0dc25d4e.jpeg",
    "https://cdn.faire.com/fastly/f5f1e1dd6d5dcff45dc5b8f9c39a3b2c6fe7a2039a7f7a7b5c8ac4e3c2312834.jpeg",
    "https://cdn.faire.com/fastly/5463cf9134328e6725801cf5549b5cce9dbeb75070dba2e5e59251003916adab.jpeg",
    "https://cdn.faire.com/fastly/4b5eb06042929b230636166bf695952b9cffb65e5b7bd5ac2d13dd725009cb61.jpeg",
    "https://cdn.faire.com/fastly/89ed5514e60806046f2ca0e5a53bd5e54de5cacc8386f74ae262507ed42d1127.jpeg",
    "https://cdn.faire.com/fastly/1ca9e76327e6f35a778ad93465102550cf930f9d3ef67d2d8c54919b013414ba.jpeg",
    "https://cdn.faire.com/fastly/10a2f66373b1333caed584e620498b84ee6b31cefc72a5840e1ed5acd26a4f39.jpeg",
    "https://cdn.faire.com/fastly/e6e495b4eca6c75e98c61a02563819f25c9d81c82914223be390e7a3868278f9.jpeg",
    "https://cdn.faire.com/fastly/b8be72c4f6e1c83c921dad527f2bedd6579fbc9d079ace77b929718e4dbbdbcb.jpeg",
    "https://cdn.faire.com/fastly/5c8a67b0d7b1bb892c9c6b85bf97b9b79de40b8f0783a49ecdeebebcf27f850c.jpeg",
    "https://cdn.faire.com/fastly/8efc229569ebecf4ec8186d1122e7bbeeb5761a9af1abbd3e23396ed530e42f3.jpeg",
    "https://cdn.faire.com/fastly/ecc327590a6971a518571274b751ca8d1a3177885de929614d88a1d72cd14772.jpeg",
    "https://cdn.faire.com/fastly/ffa4747288efd157f58593ef35c5c3734d2947a66aea7015b3d688d24461d102.jpeg",
  ],
  priceDollars: 17.32,
  description:
    'A daily wellness journal and planner for healthy living, body and mind\nAchieve health, diet and fitness goals with a planner that provides a holistic approach to wellness.\nIncludes tools to log food consumption, plan meals and fitness activities, develop positive habits, record self-care habits, track goal progress and cultivate joy.\n\nProduct details:\n* Size 5.5"x 8.2" (A5), vegan hardcover\n* Covers 13 weeks, 90 days \n* Lays flat\n* 100gsm thick paper\n* Pen holder, closure band, 2 ribbon bookmarks and an inner pocket for notes. \n* Planner stickers sheet\n\nContent includes:\n* Goal setting\n* Gratitude\n* Affirmations\n* Food journal / Meal planner\n* Fitness planner\n* Habit tracker \n* Goal progress tracking\n* Inspirational quotes',
  tags: [],
  msrpDollars: 34.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:00.837Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
